// Orders this tab sent to Scriptly and is still waiting on an MQTT outcome for. Only these get an
// outcome toast; events for other orders on the shared topic just refresh data.
//
// Reference-counted per order: the row button and the modal button each own a mutation, so two
// triggers for one order can overlap. A rejected duplicate must release only its own mark and
// leave the accepted trigger's mark in place.
const pendingCounts = new Map<string, number>()

/** One more trigger attempt is outstanding for `orderId`. */
export function markScriptlyOrderPending(orderId: string): void {
  pendingCounts.set(orderId, (pendingCounts.get(orderId) ?? 0) + 1)
}

/** One trigger attempt for `orderId` failed; drop only its own mark. */
export function releaseScriptlyOrderPending(orderId: string): void {
  const count = pendingCounts.get(orderId) ?? 0
  if (count <= 1) {
    pendingCounts.delete(orderId)
  } else {
    pendingCounts.set(orderId, count - 1)
  }
}

/** Non-consuming: is this tab still waiting on an outcome for `orderId`? */
export function isScriptlyOrderPending(orderId: string): boolean {
  return pendingCounts.has(orderId)
}

/** True (and forgets every mark for the order) when this tab was waiting on `orderId`. */
export function takePendingScriptlyOrder(orderId: string): boolean {
  return pendingCounts.delete(orderId)
}
